let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let vehicleTypes =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
            state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default vehicleTypes;




// WEBPACK FOOTER //
// ./src/redux/reducers/vehicles/vehicleTypes.js